import { colorsPalettes } from "@similarweb/styles";

import type { InsightType, IInsightTypeConfig, IInsightEntry } from "./types";
import { INSIGHT_TYPE } from "./types";

export const BADGE_TEXT_COLOR = colorsPalettes.carbon[400];

export const MIN_DAYS_FOR_INSIGHTS = 7;

export const INSIGHT_TYPE_CONFIG: Record<InsightType, IInsightTypeConfig> = {
    [INSIGHT_TYPE.Displacement]: {
        translationKey: "llm.overview_report.insights.type.displacement",
        badgeColor: colorsPalettes.mint[50],
    },
    [INSIGHT_TYPE.RankChange]: {
        translationKey: "llm.overview_report.insights.type.rank_change",
        badgeColor: colorsPalettes.yellow[100],
    },
    [INSIGHT_TYPE.VisibilityGap]: {
        translationKey: "llm.overview_report.insights.type.visibility_gap",
        badgeColor: colorsPalettes.sky[100],
    },
    [INSIGHT_TYPE.Momentum]: {
        translationKey: "llm.overview_report.insights.type.momentum",
        badgeColor: colorsPalettes.red[100],
    },
    [INSIGHT_TYPE.Invisibility]: {
        translationKey: "llm.overview_report.insights.type.invisibility",
        badgeColor: colorsPalettes.purple[50],
    },
    [INSIGHT_TYPE.Concentration]: {
        translationKey: "llm.overview_report.insights.type.concentration",
        badgeColor: colorsPalettes.brown[100],
    },
    [INSIGHT_TYPE.RankPosition]: {
        translationKey: "llm.overview_report.insights.type.rank_position",
        badgeColor: colorsPalettes.yellow[100],
    },
};

export const FAKE_INSIGHTS: IInsightEntry[] = [
    {
        type: INSIGHT_TYPE.RankChange,
        text: "In the [Topic] topic, [Your Brand] rose from #X to #Y, gaining +Z points, strengthening leadership.",
    },
    {
        type: INSIGHT_TYPE.Invisibility,
        text: "In the [Topic] topic, [Your Brand] reached X% visibility, while [Competitor] appeared in Y% of responses, signaling a wide gap.",
    },
    {
        type: INSIGHT_TYPE.Concentration,
        text: "In the [Topic] topic, [Competitor] appeared in X% of responses, signaling high brand ubiquity as a primary recommendation.",
    },
];
